import React from 'react'
import {Accepted, Approved, Rejected, Routed, Routing, Submitted} from '../enums/RecordState'
import _ from 'lodash/fp'

export const getMultiAttachmentState = (attachments) => {
  if (_.find(['state',Submitted],attachments)) {
    return Submitted
  }
  if (_.find(['state',Rejected],attachments)) {
    return Rejected
  }
  if (_.find(['state',Accepted],attachments)) {
    return Accepted
  }
  if (_.find(['state',Approved],attachments)) {
    return Approved
  }
  if (_.find(['state',Routing],attachments)) {
    return Routing
  }
  if (_.find(['state',Routed],attachments)) {
    return Routed
  }
}
